import { toLower, toString } from "lodash";
import { capitalizeFirstLetter, formatDate, getTitle } from "./utils";

const getURL = (api) => `/vsp/${api}`;

export const API_PING = getURL('health/healthcheck');

export const WHOAMI = getURL('whoami');
export const API_GRANTS = getURL('grants');
export const API_ORGS = getURL('orgs');
export const API_ORGS_ALL = getURL('orgs/org/all');
export const API_ORG_DETAILS = getURL('orgs/org');
export const API_ORG_IMPERSONATE = getURL('orgs/org/impersonate');
export const API_USERS = getURL("users");
export const API_LICENSES = getURL("licenses");
export const API_ORG_ISSUES = getURL("orgs/org/issues");
export const API_ORGS_CONTRACTS = getURL("orgs/org/contracts");
export const API_ORG_CONTRACT = getURL("orgs/org/contracts/contract");
export const API_ORGS_REPORT = getURL('orgs/report');
export const API_ORG_LICENSES = (org) => org ? getURL(`orgs/${org}/licenses`) : getURL(`orgs/org/licenses`);

export const API_USER_VERSION = getURL('users/user/version');
export const API_ISSUE_GRANT = getURL('orgs/org/users/user/grant');
export const API_USER_DETAILS = getURL("orgs/org/users/user");
export const API_DISABLE_USER = getURL("orgs/org/users/user/disable");
export const API_ACTIVATE_USER = getURL("orgs/org/users/user/activate");
export const API_SET_USER_PASS = getURL("orgs/org/users/user/set_password");
export const API_USER_SAVED_FILTERS = getURL("orgs/org/users/user/filters");
export const API_USER_SAVED_FILTER = (id) => getURL(`orgs/org/users/user/filters/${id}`);
export const API_USERS_REPORT = getURL("users/report");

export const API_SUPPORT_ISSUES = getURL("support/issues");
export const API_SUPPORT_ISSUES_COMPONENTS = getURL("support/issues/components");
export const API_SUPPORT_ISSUE = getURL("support/issues/issue");
export const API_SUPPORT_ISSUE_ATTACHMENT = getURL("support/issues/issue/attachments/attachment");
export const API_SUPPORT_ISSUE_COMMENT = getURL("support/issues/issue/comments/comment");

export const API_CONTRACTS = getURL("contracts");
export const API_CONTRACTS_ALL = getURL("contracts/all");
export const API_CONTRACT = getURL("contracts/contract");
export const API_CONTRACT_DETAILS = (contractNumber) => getURL(`contracts/${contractNumber}`);
export const API_CONTRACT_ORGS = (contractNumber) => getURL(`contracts/${contractNumber}/orgs`);
export const API_CONTRACT_PACKAGES = (contractNumber) => getURL(`contracts/${contractNumber}/packages`);
export const API_UPLOAD_CONTRACTS = getURL("orgs/org/contracts/contract/netsuite");
export const API_CONTRACTS_REPORT = getURL("orgs/contracts/report");

export const API_PRODUCTS = getURL("products");
export const API_PACKAGES_SEARCH = getURL("pkgman/packages");
export const API_PACKAGES = getURL("pkgman/packages/all");
export const API_PACKAGE = getURL("pkgman/packages/package");
export const API_VERIFY_PACKAGE = getURL("pkgman/packages/package/verify");
export const API_PACKAGE_DOWNLOAD = getURL('pkgman/packages/package/download');
export const API_PACKAGE_REGISTER = getURL("pkgman/packages/package/register");
export const API_PACKAGE_UPDATE = getURL("pkgman/packages/package/update");
export const API_PACKAGE_UPDATE_MD5 = getURL("pkgman/packages/package/update/md5");
export const API_PACKAGES_MASS_UPDATE = getURL("pkgman/packages/package/massupdate");
export const API_PACKAGE_RESTRICTIONS = getURL("pkgman/packages/package/permissions");
export const API_PACKAGE_PREREQ = getURL("pkgman/packages/package/prereq");
export const API_PACKAGES_REPORT = getURL("pkgman/packages/report");
export const API_MASTER_KIT_LIST = getURL("pkgman/packages/masterkit");
export const API_PACKAGE_FILE_UPLOADED = getURL("pkgman/packages/package/file/uploaded");
export const API_PACKAGE_DOC_LINKS = (packageNumber) => getURL("pkgman/packages/package/" + packageNumber + "/links");
export const API_PACKAGE_DOC_LINK = (packageNumber) => getURL("pkgman/packages/package/" + packageNumber + "/link");
export const API_ARCHIVE_PACKAGE = (packageNumber) => getURL("pkgman/packages/" + packageNumber + "/archive");

export const API_AUDIT_PACKAGES = getURL("audit/packages");
export const API_AUDIT_PACKAGE_FILES = getURL("audit/packages/files");
export const API_AUDIT_PACKAGE = getURL("audit/packages/package");
export const API_AUDIT_PACKAGES_DOWNLOAD = getURL("audit/packages/download");
export const API_AUDIT_REPORT = getURL("audit/report");
export const API_AUDIT_USERS = getURL("audit/users");
export const API_AUDIT_USER_GRANTS = getURL("audit/user/grants");
export const API_AUDIT_IMPERSONATIONS = getURL("audit/impersonations");
export const API_AUDIT_ORG_CONTRACTS = getURL("audit/org/contracts");
export const API_AUDIT_ORGS = getURL("audit/orgs");

export const SHC_RESULTS = getURL("shc/results");
export const SHC_NODES = getURL("shc/nodes");
export const SHC_RESULT = getURL("shc/results/result/fired");
export const SHC_RULE = getURL("shc/rule");
export const SHC_UPLOADS = getURL("shc/uploads/upload/all");
export const SHC_UPLOAD = getURL("shc/uploads/upload");

export const PAGE_SIZE = 50;
export const MAX_ATTACHMENTS_SIZE = 25*1024*1024;
export const MAX_SELECTED = 10;

export const GRANTS = [
    { key: "superadmin", title: "Superadmin", visible: false },
    { key: "admin", title: "Admin", visible: false },
    { key: "member", title: "Member", visible: true },
    { key: "owner", title: "Owner", visible: true },
    { key: "partner", title: "Partner", visible: true },
    { key: "package_tester", title: "Package Tester", visible: false},
    { key: "community_user", title: "Community User", visible: false},
    { key: "support", title: "Support", visible: false}
];

export const privileges = [
    { key: "adminRead", title: "admin read" },
    { key: "adminWrite", title: "admin write" },
    { key: "auditRead", title: "audit read" },
    { key: "jiraRead", title: "jira read" },
    { key: "jiraWrite", title: "jira write" },
    { key: "orgRead", title: "organization read" },
    { key: "orgWrite", title: "organization write" },
    { key: "packageRead", title: "package read" },
    { key: "packageWrite", title: "package write" },
    { key: "shcRead", title: "SHC read" },
    { key: "shcWrite", title: "SHC write" },
    { key: "t4Read", title: "t4 read" },
    { key: "t4Write", title: "t4 write" },
    { key: "userWrite", title: "user write" }
];

export const SYSARCH = [
    { key: "X86", title: "X86", masterKitName: "X86" },
    { key: "I64", title: "I64", masterKitName: "Integrity" },
    { key: "AXP", title: "AXP", masterKitName: "Alpha" }
];

export const MINOS = [
    { key: "V8.4-1H1", title: "V8.4-1H1", sysarch: ["I64"] },
    { key: "V8.4-2", title: "V8.4-2", sysarch: ["I64"] },
    { key: "V8.4-2L1", title: "V8.4-2L1", sysarch: ["I64", "AXP"] },
    { key: "V8.4-2L2", title: "V8.4-2L2", sysarch: ["AXP"] },
    { key: "V8.4-2L3", title: "V8.4-2L3", sysarch: ["I64"] },
    { key: "V9.1", title: "V9.1", sysarch: ["X86"], searchOnly: true },
    { key: "V9.1-A", title: "V9.1-A", sysarch: ["X86"], searchOnly: true },
    { key: "E9.2", title: "E9.2", sysarch: ["X86"], searchOnly: true },
    { key: "V9.2", title: "V9.2", sysarch: ["X86"] },
    { key: "V9.2-1", title: "V9.2-1", sysarch: ["X86"] },
    { key: "E9.2-1", title: "E9.2-1", sysarch: ["X86"] },
    { key: "V9.2-2", title: "V9.2-2", sysarch: ["X86"] },
    { key: "V9.2-3", title: "V9.2-3", sysarch: ["X86"] },
    { key: "V9.2-4", title: "V9.2-4", sysarch: ["X86"] },
    { key: "windows", title: "Windows", sysarch: ["X86","I64", "AXP"]}
];

export const PRODUCTS = [
    { "key": "Accounting", "title": "Accounting" },
    { "key": "BACKUP", "title": "BACKUP" },
    { "key": "Boot Manager", "title": "Boot Manager" },
    { "key": "Cross Tools", "title": "Cross Tools" },
    { "key": "Cross-Build tools", "title": "Cross-Build tools" },
    { "key": "DECnet", "title": "DECnet" },
    { "key": "DECthreads", "title": "DECthreads" },
    { "key": "DECwindows Motif", "title": "DECwindows Motif" },
    { "key": "Documentation", "title": "Documentation" },
    { "key": "Layered Products", "title": "Layered Products" },
    { "key": "MAIL", "title": "MAIL" },
    { "key": "Memory Management", "title": "Memory Management" },
    { "key": "Monitor", "title": "Monitor" },
    { "key": "MSCP", "title": "MSCP" },
    { "key": "Native Compilers", "title": "Native Compilers" },
    { "key": "Native Linker", "title": "Native Linker" },
    { "key": "Open Source", "title": "Open Source" },
    { "key": "Other", "title": "Other" },
    { "key": "SDA", "title": "SDA" },
    { "key": "Shadowing", "title": "Shadowing" },
    { "key": "SYSBOOT", "title": "SYSBOOT" },
    { "key": "SYSGEN", "title": "SYSGEN" },
    { "key": "SYSMAN", "title": "SYSMAN" },
    { "key": "Test Component", "title": "TEST COMPONENT" },
    { "key": "Traceback", "title": "Traceback" },
    { "key": "Virtualization", "title": "Virtualization" },
    { "key": "VMS Clusters", "title": "VMS Clusters" },
    { "key": "VSI TCP/IP", "title":  "VSI TCP/IP" }
];

export const SWTYPES = [
    { key: "d", title: "Documentation"},
    { key: "e", title: "ECO kit"},
    { key: "l", title: "Layered product"},
    { key: "v", title: "OE"},
    { key: "o", title: "Open-source" },
    { key: "w", title: "Windows Application"}
];

export const KITSTYLE = [
    { key: "p", title: "PCSI" },
    { key: "z", title: "ZIPEXE" },
    { key: "c", title: "ZIP" },
    { key: "w", title: "Windows Installer" },
    { key: "o", title: "Other"}
];

export const JIRA_URL = "https://vsi.atlassian.net"

export const YESNO = [
    { key: 1, title: "Yes"},
    { key: 0, title: "No" }
];

export const ECO_RATING = [
    { key: 1, title: 1 },
    { key: 2, title: 2 },
    { key: 3, title: 3 }
];

export const USER_STATUS = [
    { key: "created", title: "Created" },
    { key: "deleted", title: "Deleted" },
    { key: "disabled", title: "Disabled" },
    { key: "activated", title: "Activated" },
    { key: "updated", title: "Updated" },
    { key: "new_default_org", title: "New default organization" },
    { key: "password_changed", title: "Password changed" },
    { key: "name_changed", title: "Name changed" }
];

export const GRANT_STATUS = [
    { key: "granted", title: "Granted" },
    { key: "revoked", title: "Revoked" }
];

export const CONTRACT_STATUS = [
    { key: "registered", title: "Registered" },
    { key: "deleted", title: "Deleted" },
    { key: "updated", title: "Updated" }
];

export const ORG_STATUS = [
    { key: "created", title: "Created" },
    { key: "deleted", title: "Deleted" },
    { key: "updated", title: "Updated" }
];

export const COMMUNITY_ORGS = ["vac", "vci", "vxc"];

export const JIRA_STATUS = [
    { key: "new", title: "New" },
    { key: "open", title: "Open" },
    { key: "backlog", title: "Backlog" },
    { key: "awaiting_qa_verification", title: "Awaiting QA Verification" },
    { key: "in_progress", title: "In Progress" },
    { key: "done", title: "Done" },
    { key: "under_investigation", title: "Under Investigation" },
    { key: "awaiting_customer_verification", title: "Awaiting Customer Verification" }
]

export const REPORT_FORMATS = [
    { key: "pdf", title: "PDF file" },
    { key: "csv", title: "CSV file" },
    { key: "html", title: "HTML file" }
]

export const INTERVALS = [
    { key: "day", title: "Day" },
    { key: "week", title: "Week" },
    { key: "month", title: "Month" },
    { key: "quarter", title: "Quarter" },
    { key: "year", title: "Year" }
];

export const PACKAGE_STATUS = [
    { key: "registered", title: "Registered" },
    { key: "deleted", title: "Deleted" },
    { key: "verified", title: "Verified" },
    { key: "unverified", title: "Not Verified" },
    { key: "updated", title: "Updated" },
    { key: "file_uploaded", title: "File added" },
    { key: "file_deleted", title: "File deleted"},
    { key: "archived", title: "Archived" },
    { key: "restored", title: "Restored" }
];

export const PACKAGE_FIELDS = [
    { key: "packagename", title: "package name" },
    { key: "restartrequired", title: "restart required", render: (d) => getTitle(toLower(d), YESNO) },
    { key: "type", title: "kit type", render: (d) => getTitle(toLower(d), SWTYPES) },
    { key: "style", title: "kit style", render: (d) => getTitle(toLower(d), KITSTYLE) },
    { key: "sysarch", title: "system architecture", render: (d) => typeof d === "string" ? d.replace(/(\"?)(\[?)(\]?)/g, "") : d},
    { key: "minos", title: "os version", render: (d) => typeof d === "string" ? d.replace(/(\"?)(\[?)(\]?)/g, "") : d },
    { key: "ecorating", title: "eco rating" },
    { key: "releasedate", title: "release date", render: (d) => formatDate(d, "DD-MMM-YYYY")},
    { key: "archivedversion", title: "archived version", render: (d) => getTitle(toLower(d), YESNO) },
    { key: "productname", title: "product name" }
];

export const PERMISSIONS_FIELDS = [
    { key: "contracts", title: "contracts", render: (d) => typeof d == "string" ? d.split(",").join(", ") : d },
    { key: "ecokits", title: "rights to ecokits", render: (d) => capitalizeFirstLetter(toString(d != 0)) },
    { key: "rToMinorRel", title: "rights to minor releases", render: (d) => capitalizeFirstLetter(toString(d != 0)) }
]

export const dateFormat = "YYYY-MM-DD";